import { getRegisterFunction } from '../../utils/register.js';
import { OneUxSliderElement } from './OneUxSliderElement.js';
export const register = getRegisterFunction(OneUxSliderElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-slider': OneUxSliderElement;
    "slider-d678e2d28b3e10f34ae7f0a2cf4e842b": OneUxSliderElement;
  }
}